import React from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toolCategories } from '../config/tools';
import { pagePath } from '../seo/seoData';

interface FooterProps {
  lang: string;
}

const Footer: React.FC<FooterProps> = ({ lang }) => {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider', mt: 8, py: 5 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <CodeIcon sx={{ color: 'primary.main' }} />
              <Typography fontWeight={800}>{t('common.appName')}</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {t('footer.description')}
            </Typography>
          </Grid>
          {toolCategories.map((category) => (
            <Grid item xs={6} sm={4} md={1.6} key={category.id}>
              <Typography variant="subtitle2" component="h2" sx={{ mb: 1.5, fontWeight: 700 }}>
                {t(`categories.${category.id}`)}
              </Typography>
              <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
                {category.tools.map((tool) => (
                  <Box component="li" key={tool.id} sx={{ mb: 1 }}>
                    <Link component={RouterLink} to={pagePath(lang, tool.slug)} color="text.secondary" underline="hover" variant="body2">
                      {t(`tools.${tool.id}.shortTitle`)}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 4 }}>
          {t('footer.rights', { year: new Date().getFullYear() })}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
